import { userType as userRole } from "Models/Enums";
import { Button, Display } from "../Button/Button";

type CustomerViewType = {
	type: 'Customer';
	businessId: string;
}
type ClientViewType = {
	type: 'Client';
	businessId: string;
	organisationId: string;
}
type AlertPaymentMethodNotfoundProps = {
	viewType: CustomerViewType | ClientViewType;
	userType: userRole
}

export function AlertPaymentMethodNotfound(props: AlertPaymentMethodNotfoundProps) {
	const {
		userType,
		viewType,
	} = props;

	// Redirect to tab on the business entity to add payment for the provided business Id
	const paymentMethodUrl = viewType.type === 'Customer'
		? `/hub/organisation/business-entities/${viewType.businessId}/billing`
		: `/hub/clients/${viewType.organisationId}/business-entities/${viewType.businessId}/billing`;

	// If the user can mutate a payment, show them redirect line
	// Otherwise, tell them to contact someone who can
	let userSpecificContent = <></>;
	if (['SUPER_USER', 'ORGANISATION_MANAGER', 'ADMIN'].includes(userType)) {
		userSpecificContent = (
			<p>Please add a payment method {" "}
				<Button
					onClick={() => window.open(paymentMethodUrl)}
					display={Display.Text}><u>here</u></Button>
				{" "} to continue.
			</p>
		)
	} else {
		userSpecificContent = <p>Please contact your business admin to add a payment method.</p>
	}

	return (
		<div className="alert alert__warning alert-payment-method-notfound">
			<p>No payment methods are linked to this business.</p>
			{userSpecificContent}
		</div>
	);
}

